import uniq from 'lodash/uniq';
import * as types from '../constants';

const items = (state = [], action) => {
  const list = (part, action) => uniq([
    ...part,
    ...action.response.result,
  ]);

  switch (action.type) {
    case types.IMPORT_APPOINTMENTS:
      return action.response.result;
    case types.GET_APPOINTMENT:
      if (action.change) {
        switch (action.change) {
          case 'booked':
            return list(state, action);
          default:
            return state;
        }
      }
      return state;
    case types.CLEAR_APPOINTMENTS:
      return [];
    default:
      return state;
  }
};

export default items;
